import type { FiltersAdapter, FilterPreferences, FiltersConfigLocale } from '@tractian/ui-filters'

const FILTERS_STORAGE_KEY = '@tractian-filters'

function readFiltersStore(): Record<string, unknown> {
  try {
    return JSON.parse(localStorage.getItem(FILTERS_STORAGE_KEY) ?? '{}') ?? {}
  } catch {
    return {}
  }
}

function writeFiltersStore(store: Record<string, unknown>): void {
  localStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify(store))
}

export const filtersAdapter: FiltersAdapter<string> = {
  getSavedFilters: async () => [],
  saveFilter: async (_name, filter) => ({
    ...filter,
    id: crypto.randomUUID(),
    name: filter.name ?? 'Custom',
    global: false,
  }),
  deleteFilter: async () => {},
  getPreferences: (name) => {
    const store = readFiltersStore()
    return store[`new-filters:${name}`] as FilterPreferences | undefined
  },
  setPreferences: (name, prefs) => {
    const store = readFiltersStore()
    store[`new-filters:${name}`] = prefs
    writeFiltersStore(store)
  },
}

export const filtersLocale: FiltersConfigLocale = {
  lang: {
    form: {
      editFilter: 'Edit Filter',
      saveFilter: 'Save Filter',
      filterName: 'Filter Name',
      filterNamePlaceholder: 'Enter filter name',
      global: 'Global',
      requiredError: 'Required',
      deleteFilter: 'Delete filter?',
      deleteGlobalFilterMessage: 'This is a global filter',
    },
    common: {
      edit: 'Edit',
      clear: 'Clear',
      save: 'Save',
      search: 'Search',
      cancel: 'Cancel',
      delete: 'Delete',
      saveAsNew: 'Save as new',
      addFilter: 'Add filter',
      fixFilter: 'Fix filter',
      unpinFilter: 'Unpin',
      savedFilters: 'Saved filters',
      saveAsExisting: 'Save as existing',
      noFiltersSaved: 'No saved filters',
      noFiltersFound: 'No filters found',
      companyFilters: 'Company filters',
      personalFilters: 'Personal filters',
    },
  },
}
